import styled from 'styled-components';

import { BigButton } from '../Buttons';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 19.2px;
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const CutomBtn = styled(BigButton)`
  width: auto;
`;
